import http from "./http";

const getVehicleType = () => {
  return http.get("/vehicles/all-vehicles");
};

const getVehicleCategory = () => {
  return http.get("/vehicles/all-vehicles-category");
}

export default {
  getVehicleType,
  getVehicleCategory
};
